import { useState , useEffect} from 'react';
import { Navbar, Container, Offcanvas, Dropdown, Modal, Button, Form } from "react-bootstrap";
import { ssoLogOut } from "../../Services/auth";
import logo from '../../assets/images/s3sLogo.png';
import supportIcon from '../../assets/images/setting-icon-web.svg';
import toggleMenuIcon from '../../assets/images/toggle-menu-icon.svg';
import { ReactComponent as Logout } from "../../assets/images/logout-web-icon.svg";
import { useNavigate, useLocation, useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { setAuth } from "../../Redux/Slice/authSlice";
import { setRequestType } from "../../Redux/Slice/requestTypeSlice";
import './header.css';
import { getUserRole } from "../../Services/auth";


const Header = () => {
    const { deal_id, countryId } = useParams();
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const location = useLocation();

    // Get current request type from Redux (optional, but keeps consistency)
    const requestType = useSelector((state) => state.requestType?.RequestType);

    const [showEmailModal, setShowEmailModal] = useState(false);
    const [rememberChoice, setRememberChoice] = useState(false);

     useEffect(() => {
         fetchUserRole(localStorage.email, localStorage.access_token)
        }, [localStorage]);

    // Check if user has previously chosen a preference
    const getUserEmailPreference = () => {
        return localStorage.getItem('emailClientPreference');
    };

    // Save user's email preference
    const saveEmailPreference = (preference) => {
        localStorage.setItem('emailClientPreference', preference);
    };

    const fetchUserRole = async (email, token) => {
        try {
            const res = await getUserRole(email, token);
            if (res && res?.data?.status === 200) {
                if (res?.data?.data?.roles[0]) {
                    localStorage.setItem('userRole', res?.data?.data?.roles[0])
                }
            }
        } catch (error) {
            console.error("Error fetching user role:", error);
        }
    };


    let handleLogout = async () => {
        dispatch(setAuth({ isAuthenticated: false, token: '', loginType: '' }));
        localStorage.clear()
        window.location.href = "/login";
        return
        let res = await ssoLogOut(localStorage?.access_token);
        if (res && res.status === '200') {
            dispatch(setAuth({ isAuthenticated: false, token: '', loginType: '' }));
            navigate(`/login`);
            localStorage.clear();
            window.location.reload();
        }
    };

    let getInitials = () => {
        const firstName = localStorage?.firstName?.charAt(0) || "";
        const surname = localStorage?.lastName?.charAt(0) || "";
        if (firstName.length > 0 && surname.length > 0) {
            return firstName[0] + surname[0];
        } else if (firstName.length > 0 && surname.length <= 0) {
            return firstName[0];
        } else {
            return "";
        }
    };

    // Function to get email content
    const getEmailContent = () => {
        const userName = localStorage?.userName || 'User';
        const userEmail = localStorage?.email || '';
        const userId = localStorage?.UserId || '';
        const firstName = localStorage?.firstName || '';
        const lastName = localStorage?.lastName || '';

        const subject = `Support Request - ${userName} (User ID: ${userId})`;

        const body = `Dear Support Team,

I need assistance with the following:

Issue Description:
[Please describe your issue here]

Additional Details:
- User: ${userName}
- Full Name: ${firstName} ${lastName}
- Email: ${userEmail}
- User ID: ${userId}
- Date: ${new Date().toLocaleDateString()}
- Time: ${new Date().toLocaleTimeString()}

Please let me know what additional information you need.

Thank you,
${userName}`;

        return {
            subject: encodeURIComponent(subject),
            body: encodeURIComponent(body),
            supportEmail: "support@yourcompany.com" // REPLACE WITH ACTUAL SUPPORT EMAIL
        };
    };

    // Open desktop email client (default)
    const openDesktopEmail = () => {
        const { subject, body, supportEmail } = getEmailContent();
        const mailtoLink = `mailto:${supportEmail}?subject=${subject}&body=${body}`;
        window.location.href = mailtoLink;
    };

    // Open web email (Office 365/Gmail)
    const openWebEmail = (provider = 'outlook') => {
        const { subject, body, supportEmail } = getEmailContent();

        let webLink;
        if (provider === 'outlook') {
            // Office 365/Outlook Web
            webLink = `https://outlook.office.com/mail/deeplink/compose?to=${supportEmail}&subject=${subject}&body=${body}`;
        } else {
            // Gmail
            webLink = `https://mail.google.com/mail/?view=cm&fs=1&to=${supportEmail}&su=${subject}&body=${body}`;
        }

        window.open(webLink, '_blank', 'noopener,noreferrer');
    };

    const handleSupportClick = () => {
        // Check if user has a saved preference
        const savedPreference = getUserEmailPreference();

        if (savedPreference) {
            // Use saved preference
            if (savedPreference === 'desktop') {
                openDesktopEmail();
            } else if (savedPreference === 'web-outlook') {
                openWebEmail('outlook');
            } else if (savedPreference === 'web-gmail') {
                openWebEmail('gmail');
            }
        } else {
            // Show modal for first time or if no preference saved
            setShowEmailModal(true);
        }
    };

    const handleEmailChoice = (choice) => {
        if (rememberChoice) {
            saveEmailPreference(choice);
        }

        setShowEmailModal(false);

        switch (choice) {
            case 'desktop':
                openDesktopEmail();
                break;
            case 'web-outlook':
                openWebEmail('outlook');
                break;
            case 'web-gmail':
                openWebEmail('gmail');
                break;
            default:
                openDesktopEmail();
        }
    };

    const clearEmailPreference = () => {
        localStorage.removeItem('emailClientPreference');
        setShowEmailModal(true); // Show modal again
    };

    let handleLoadoutClick = () => {
        dispatch(setRequestType({ RequestType: 'Loadout' }));
        localStorage.setItem('requestType', 'Loadout');
        navigate('/dashboard');
    };

    let handleResupplyClick = () => {
        dispatch(setRequestType({ RequestType: 'Resupply' }));
        localStorage.setItem('requestType', 'Resupply');
        navigate('/resupply');
    };

    // Determine active button based on current path
    const isLoadoutActive = location.pathname.includes('/dashboard');
    const isResupplyActive = location.pathname.includes('/resupply');

    return (
        <header className="header-layout">
            <Navbar expand="lg" className="bg-tranparent">
                <Container fluid>
                    <Navbar.Brand href="#home">
                        <span className="logo-brand-wt">
                            <img src={logo} alt="logo" />
                        </span>
                    </Navbar.Brand>
                    <Navbar.Offcanvas
                        id="offcanvasNavbar-expand-lg"
                        aria-labelledby="offcanvasNavbarLabel-expand-lg"
                        placement="start"
                        className="sidemenu-canvas ms-lg-auto"
                    >
                        <Offcanvas.Header closeButton>
                            <Offcanvas.Title id="offcanvasNavbarLabel-expand-lg">
                                <span className="logo-brand-wt">
                                    <img src={logo} alt="logo" />
                                </span>
                            </Offcanvas.Title>
                        </Offcanvas.Header>
                        <Offcanvas.Body>
                            <div className="right-side-menu ms-auto">
                                <ul className="d-flex align-items-center mb-0 menu-itm-web">
                                    <li>
                                        <button
                                            onClick={handleLoadoutClick}
                                            type="button"
                                            className={`btn btn-home ${isLoadoutActive ? 'active' : ''}`}
                                        >
                                            Loadout
                                        </button>
                                    </li>
                                    <li>
                                        <button
                                            onClick={handleResupplyClick}
                                            type="button"
                                            className={`btn btn-home ${isResupplyActive ? 'active' : ''}`}
                                        >
                                            Resupply
                                        </button>
                                    </li>
                                </ul>
                            </div>
                        </Offcanvas.Body>
                    </Navbar.Offcanvas>
                    <div className="right-side-menu">
                        <ul className="d-flex align-items-center mb-0 menu-itm-web">
                            <li className="bell-icon-button">
                                <button
                                    type="button"
                                    className="btn btn-notific-bell p-0 mx-3"
                                    onClick={handleSupportClick}
                                    title="Contact Support"
                                >
                                    <img src={supportIcon} alt="Support" />
                                </button>
                            </li>
                            <li>
                                <Dropdown>
                                    <Dropdown.Toggle variant="btn-profile-drop" className="p-0" id="dropdown-basic">
                                        {getInitials()}
                                    </Dropdown.Toggle>

                                    <Dropdown.Menu align="end" className="profile-dropdown-menu">
                                        <div className="full-profile-body">
                                            {/* <div className="d-flex align-items-center justify-content-between mb-4">
                                                <h3 className="title-br-nm">S3S</h3>
                                                <div className="side-profile-sgn">
                                                    <button onClick={handleLogout} type="button" className="btn p-0 border-0 btn-sign-out">
                                                        Sign Out
                                                    </button>
                                                </div>
                                            </div> */}
                                            <div className="flx-info-profile p-3">
                                                <div className="left-circle-nm">
                                                    <div className="nm-short-cont">
                                                        <span className="round-txt-content">{getInitials()}</span>
                                                    </div>
                                                </div>
                                                <div className="side-profile--info">
                                                    <h3 className="title-user-nm">{localStorage?.userName}</h3>
                                                    <div style={{ fontWeight: 600 }} className="eml-content-wts">
                                                        <span className="txt-email-wt">{localStorage?.userRole}</span>
                                                    </div>
                                                    <div className="eml-content-wts">
                                                        <span className="txt-email-wt">{localStorage?.email}</span>
                                                    </div>

                                                </div>
                                            </div>
                                            <div className="sign-out-profile pb-2">
                                                <button onClick={handleLogout} type="button" className="btn border-0 btn-sign-out">
                                                    <Logout className='me-2' />Log Out
                                                </button>
                                            </div>
                                        </div>
                                    </Dropdown.Menu>
                                </Dropdown>
                            </li>
                        </ul>
                    </div>
                    <Navbar.Toggle aria-controls="offcanvasNavbar-expand-lg" className="border-0 p-0 menu-side-toggle ms-2 shadow-none">
                        <img src={toggleMenuIcon} alt="icon" />
                    </Navbar.Toggle>
                </Container>
            </Navbar>

            {/* Email Client Selection Modal */}
            <Modal show={showEmailModal} onHide={() => setShowEmailModal(false)} centered>
                <Modal.Header closeButton>
                    <Modal.Title>Choose Email Client</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <p className="mb-3">How would you like to contact support?</p>

                    <div className="d-grid gap-3">
                        <Button
                            variant="outline-primary"
                            onClick={() => handleEmailChoice('desktop')}
                            className="text-start p-3"
                        >
                            <div className="d-flex align-items-center">
                                <div className="me-3">
                                    <i className="bi bi-desktop fs-4"></i>
                                </div>
                                <div>
                                    <h6 className="mb-1">Desktop Email Client</h6>
                                    <small className="text-muted">
                                        Opens your default desktop email application (Outlook, Apple Mail, etc.)
                                    </small>
                                </div>
                            </div>
                        </Button>

                        <Button
                            variant="outline-primary"
                            onClick={() => handleEmailChoice('web-outlook')}
                            className="text-start p-3"
                        >
                            <div className="d-flex align-items-center">
                                <div className="me-3">
                                    <i className="bi bi-microsoft fs-4"></i>
                                </div>
                                <div>
                                    <h6 className="mb-1">Office 365 / Outlook Web</h6>
                                    <small className="text-muted">
                                        Opens Office 365 in your web browser
                                    </small>
                                </div>
                            </div>
                        </Button>
                    </div>

                    {/* Remember my choice checkbox */}
                    <Form.Check
                        type="checkbox"
                        label="Remember my choice"
                        checked={rememberChoice}
                        onChange={(e) => setRememberChoice(e.target.checked)}
                        className="mt-3"
                    />
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={() => setShowEmailModal(false)}>
                        Cancel
                    </Button>
                </Modal.Footer>
            </Modal>
        </header>
    );
};

export default Header;